<template>
  <el-dialog title="导入"
             :visible.sync="dialogVisible"
             :show-close="false"
             custom-class="importDialog"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <!-- <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <el-row>
        <el-col :span="12">
          <el-form-item prop="profession"
                        label="行业">
            <el-select clearable
                       v-model="form.profession"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in platlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="business"
                        label="商家">
            <el-select v-loading="ptnListLoading"
                       clearable
                       v-model="form.business"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in ptnlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="store"
                        label="店铺">
            <el-select v-loading="shopListLoading"
                       clearable
                       v-model="form.store"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in shoplists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>

        </el-col>
      </el-row>
      <el-form-item label="文件"
                    required>
        <el-upload :on-remove="handleRemove"
                   class="upload-demo"
                   drag
                   action="fake"
                   accept=".xlsx, .xls, .csv"
                   :limit="1"
                   :auto-upload="false"
                   :on-change="handleChange"
                   ref="refUpload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <!-- <div class="el-upload__trigger" slot="trigger">只能上传 xlsx文件，且不超过 30M</div> -->
          <div class="el-upload__tip"
               slot="tip">只能上传 xlsx xls csv文件，且不超过 30M</div>
          <div class="el-upload__tip"
               slot="tip">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-button type="primary"
                           icon="el-icon-document"
                           @click="downloadTemp">点击下载模板文件</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-upload>
      </el-form-item>

    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resolvingXLSX, rfmResolvingXLSX } from '@/utils'
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
export default {
  mixins: [getplatlists, getptnlists, getshoplists],
  name: 'ImportDialog',
  data() {
    return {
      dialogVisible: false,
      rules: {},
      form: {
        profession: '',
        business: '',
        store: '',
      },
      formworkFile: '',
      rules: {
        profession: [{ required: true, message: '必填项', trigger: 'blur' }],
        business: [{ required: true, message: '必填项', trigger: 'blur' }],
        store: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      file: null,
      fileHeader: [],
    }
  },
  created() {
    // this.getTableData();
    this.getImportTemp()
  },
  methods: {
    async getImportTemp() {
      // this.loading = true

      // let name = this.$route.meta.routeName.split('.')[1]
      let name = this.$route.name
      console.log('route', this.$route)
      console.log(name)
      let { data, err } = await this.axiosApi({
        url: `getFormworkFile/${name}`,
      })
      if (data && data.data.meta.status === 200) {
        console.log('data', data.data.data)
        this.formworkFile = data.data.data
      }
    },
    downloadTemp() {
      if (this.formworkFile) {
        window.location.href = this.formworkFile
      }
    },
    show() {
      this.fileHeader = [
        '店铺名',
        '商品名',
        '平台商品名',
        '商品型号',
        'SPU',
        'SKU',
        '商品类型',
        '商品一级分类',
        '商品二级分类',
        '商品三级分类',
        '市场价',
      ]
      // console.log('导入文件头 信息', list)
      // this.fileHeader = [
      //   '店铺名',
      //   '商品名',
      //   '平台商品名',
      //   '商品型号',
      //   'SPU',
      //   'SKU',
      //   '商品类型',
      //   '商品一级分类',
      //   '商品二级分类',
      //   '商品三级分类',
      //   '市场价',
      // ]
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.file = null
      this.form = { profession: '', business: '', store: '' }
      this.$refs.refDialog.resetFields()
      this.$refs.refUpload.clearFiles()
    },
    handleRemove(file, fileList) {
      console.log('file, fileList', file, fileList)
      this.file = null
    },
    handleChange(file, fileList) {
      console.log('handleChange file', file)
      let list = file.name.split('.')
      let suffix = list[list.length - 1]
      let arr = ['xlsx', 'xls', 'csv']
      if (!arr.includes(suffix)) {
        this.$refs.refUpload.clearFiles()
        this.$message.error('导入模板有误，请检查导入文件格式')
      } else {
        this.file = file.raw
      }
      console.log('this.file', this.file)
    },
    async submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return
      }

      // else
      if (!this.file) {
        this.$message.error({
          message: '请添加文件',
          // offset: 61,
        })
        return
      }
      if (this.file.size > 30 * 1024 ** 2) {
        this.$message.error({
          message: '文件大小不能超过 30M',
          // offset: 61,
        })
      } else {
        // 判断文件 列的数目
        // debugger;
        const bool = await resolvingXLSX(this.file, this.fileHeader)
        console.log('bool', bool)
        if (bool) {
          // reportname 当前页面的URL
          console.log('this.$route', this.$route)
          this.form.file = this.file
          this.form.reportname = this.$route.path.replace('/', '')
          // console.log(form)

          let fields = {
            store: '店铺名', //店铺名
            title: '商品名', //商品名
            platTitle: '平台商品名', //平台商品名
            prdModel: '商品型号', //商品型号
            spuCode: 'SPU', //SPU
            skuCode: 'SKU', //SKU
            prdType: '商品类型', //商品类型
            category1: '商品一级分类', //商品一级分类
            category2: '商品二级分类', //商品二级分类
            category3: '商品三级级分类', //商品二级分类
            price: '市场价', //价格
          }
          let xlsData = await rfmResolvingXLSX(this.file, fields)
          console.log(xlsData)
          if (xlsData) {
            for (var item of xlsData) {
              console.log(item.store, this.form.store)
              if (item.store != this.form.store) {
                this.$refs.refUpload.clearFiles()

                return this.$message.error(
                  '“店铺名”和导入时选择的店铺不同，请检查'
                )
              }
            }
          }

          this.$emit('submit', {
            skuLists: xlsData,
            business: this.form.business,
            store: this.form.store,
            profession: this.form.profession,
          })
          this.hide()
        } else {
          this.$message.error('导入模板字段名不正确，请检查字段名')
          console.log('this.$route', this.$route)
          this.form.file = this.file
          console.log(this.form)
          this.form.reportname = this.$route.path.replace('/', '')
          this.$refs.refUpload.clearFiles()

          // this.$emit("submit", this.form);
          this.hide()
        }
      }

      // 相父组件派发事件和数据
    },
  },
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 600px;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/rfmImportDialog/index.vue